/* eslint-disable class-methods-use-this */
import dayjs from 'dayjs';
import {
  //   collection,
  //   setDoc,
  //   updateDoc,
  //   DocumentData,
  //   FieldValue,
  //   arrayUnion,
  deleteDoc,
  doc,
  addDoc,
  serverTimestamp,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  where,
  orderBy,
  FirestoreError,
  QuerySnapshot,
  Timestamp,
  updateDoc,
} from 'firebase/firestore';
import ConsoleHelper from 'src/shared/helpers/consoleHelper';
import { appConfig, sellingCollection } from '../firebaseConf';
import { Category } from './category.service';

export interface Selling {
  companyId: string;
  date: Date;
  category: Category;
  categoryParent: string;
  title: string;
  description: string;
  price: number;
  quantity: number;
  created?: Timestamp;
  createdBy: string;
}

export const createSelling = (userId: string, item: Selling) => {
  return addDoc(sellingCollection, {
    ...item,
    created: serverTimestamp(),
    createdBy: userId,
  });
};

export const getSelling = (id: string) => {
  const documentRef = doc(sellingCollection, id);
  return getDoc(documentRef);
};

export const deleteSelling = (id: string) => {
  const documentRef = doc(sellingCollection, id);
  return deleteDoc(documentRef);
};

export const getSellings = () => {
  return getDocs(sellingCollection);
};

export const setCompanyIDOnAllSellings = () => {
  getDocs(sellingCollection).then((snapshot) => {
    snapshot.forEach((x) => {
      const docRef = doc(sellingCollection, x.id);

      updateDoc(docRef, { companyId: appConfig.companyId })
        .then(() => {
          ConsoleHelper.log(`Document ${x.id} updated successfully.`);
        })
        .catch((error) => {
          ConsoleHelper.error(`Error updating document ${x.id}: ${error}`);
        });
    });
  });
};

export const streamSellings = (
  snapshot: (snapshot: QuerySnapshot<Selling>) => void,
  error: (error: FirestoreError) => void,
  start?: Date,
  end?: Date,
) => {
  let q = query(sellingCollection, orderBy('date', 'desc'));
  q = query(q, where('companyId', '==', appConfig.companyId));
  if (start && end) {
    const startTimestamp = Timestamp.fromDate(dayjs(start).toDate());
    const endTimestamp = Timestamp.fromDate(dayjs(end).toDate());
    q = query(
      sellingCollection,
      where('companyId', '==', appConfig.companyId),
      where('date', '>=', startTimestamp),
      where('date', '<=', endTimestamp),
      orderBy('date', 'desc'),
    );
  }

  return onSnapshot(q, { includeMetadataChanges: true }, snapshot, error);
};
